export const AddIcon = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.5 9.5H13.5"
      stroke="#F6FCFF"
      strokeWidth="1.6875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 14V5"
      stroke="#F6FCFF"
      strokeWidth="1.6875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
